import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { Box as PRCBox } from '@primer/react';
import { Link, Button, Heading, InlineLink, Text } from '@primer/react-brand';
import { version } from "../../../../../../packages/react/package.json";
import { LinkExternalIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  HeroLayout,
  InlineCode,
  PRCBox,
  Link,
  Button,
  Heading,
  InlineLink,
  Text,
  version,
  LinkExternalIcon,
  React
};